// Shim for dhtmlx-gantt.
// The dhtmlxGanttESM plugin in vite.config.mts wraps the UMD bundle with
// proper ESM exports, so we can import named exports directly.

import type {
  GanttStatic,
  GanttEnterprise
} from "dhtmlx-gantt/codebase/dhtmlxgantt";

export type { ZoomLevel } from "dhtmlx-gantt/codebase/dhtmlxgantt";

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore — named exports provided by dhtmlxGanttESM plugin
import {
  Gantt as _Gantt,
  gantt as _gantt
} from "dhtmlx-gantt/codebase/dhtmlxgantt";

export const gantt: GanttStatic = _gantt;
export const Gantt: GanttEnterprise = _Gantt;
